import { Spinner } from './ui/spinner';
import { cn } from '../lib/utils';
import { useDocumentTitle } from '../hooks/useDocumentTitle';

export function LoadingState({ message = 'Loading…' }: { message?: string }) {
    return (
        <div
            role="status"
            className="flex min-h-32 flex-col items-center justify-center gap-3 py-8"
        >
            <Spinner size="lg" label={null} className="text-primary-500" />
            <p className="text-sm font-medium text-muted-foreground">{message}</p>
        </div>
    );
}

export function LoadingPage({ message = 'Loading…' }: { message?: string }) {
    useDocumentTitle(message);

    return (
        <main className="flex min-h-screen items-center justify-center bg-admin-app p-4">
            <div
                role="status"
                className="flex min-w-64 flex-col items-center gap-3 rounded-xl border bg-card p-6 shadow-sm animate-loading-in"
            >
                <Spinner size="lg" label={null} className="text-primary-500" />
                <p className="text-sm font-medium text-muted-foreground">{message}</p>
            </div>
        </main>
    );
}

export function InlineSpinner({ className, label }: { className?: string; label?: string | null }) {
    return <Spinner size="xs" label={label} className={cn('inline-block', className)} />;
}
